import { useRefinementList, useSortBy } from "react-instantsearch";
import { productSortOptions } from "./client";

export enum FilterAttribute {
    CATEGORY = "named_tags.category",
    PRODUCT_TYPE = "product_type",
    ROOM = "meta.custom.rooms",
    COLOUR = "meta.custom.colours",
    BRAND = "vendor",
    DESIGNER = "named_tags.designer",
    RANGE = "named_tags.range",
};

// define toggle filter attributes and on values
export const ToggleFilterAttribute = {
    BEST_SELLERS: {
        attribute: "meta.custom.best_seller",
        on: true
    },
    COMMERCIAL: {
        attribute: "tags",
        on: "Commercial"
    },
    TRANSACTABLE_ONLINE: {
        attribute: "named_tags.availability",
        on: "Shop online"
    },
    IN_STOCK_AND_READY_TO_SHIP: {
        attribute: "tags",
        on: "Ready to ship"
    },
    ON_SALE: {
        attribute: "named_tags_names",
        on: "sale"
    }
};

// Shared toggle filter configurations
export interface ToggleFilterConfig {
    label: string;
    attribute: string;
    on?: string | boolean;
    type: 'toggle' | 'refinementList';
}

export const toggleFilters: ToggleFilterConfig[] = [
    {
        label: window.algoliaShopify?.config?.filterOptions?.bestSellers || 'Best Sellers',
        attribute: ToggleFilterAttribute.BEST_SELLERS.attribute,
        on: ToggleFilterAttribute.BEST_SELLERS.on,
        type: 'toggle'
    },
    {
        label: window.algoliaShopify?.config?.filterOptions?.commercial || 'Suitable for Commercial Applications',
        attribute: ToggleFilterAttribute.COMMERCIAL.attribute,
        on: ToggleFilterAttribute.COMMERCIAL.on,
        type: 'refinementList'
    },
    {
        label: window.algoliaShopify?.config?.filterOptions?.transactable || 'Transactable Online',
        attribute: ToggleFilterAttribute.TRANSACTABLE_ONLINE.attribute,
        on: ToggleFilterAttribute.TRANSACTABLE_ONLINE.on,
        type: 'refinementList'
    },
    {
        label: window.algoliaShopify?.config?.filterOptions?.inStock || 'In Stock & Ready to Ship',
        attribute: ToggleFilterAttribute.IN_STOCK_AND_READY_TO_SHIP.attribute,
        on: ToggleFilterAttribute.IN_STOCK_AND_READY_TO_SHIP.on,
        type: 'refinementList'
    },
    {
        label: window.algoliaShopify?.config?.filterOptions?.onSale || 'On Sale',
        attribute: ToggleFilterAttribute.ON_SALE.attribute,
        on: ToggleFilterAttribute.ON_SALE.on,
        type: 'refinementList'
    },
];

export function useVirtualFilters() {
    // This is here to save the state of the sort filter when drawer closes...
    // -- Not sure if this is the best place for it, but it works...
    const sortBy = useSortBy({ items: productSortOptions })

    const category = useRefinementList({ attribute: FilterAttribute.CATEGORY });
    const productType = useRefinementList({ attribute: FilterAttribute.PRODUCT_TYPE });
    const room = useRefinementList({ attribute: FilterAttribute.ROOM });
    const colour = useRefinementList({ attribute: FilterAttribute.COLOUR });
    const brand = useRefinementList({ attribute: FilterAttribute.BRAND });
    const designer = useRefinementList({ attribute: FilterAttribute.DESIGNER });
    const range = useRefinementList({ attribute: FilterAttribute.RANGE });

    return {
        sortBy,
        category,
        productType,
        room,
        colour,
        brand,
        designer,
        range
    }
}

export function VirtualFilters() {
    useVirtualFilters()
    return null;
}